module.exports = __webpack_public_path__ + "img/placeholder.ad78df1b.svg";